import React, { useEffect } from "react";
import { Card, Col, Row, Space, Typography } from "antd";
import { useTrackingCode } from "react-hubspot-tracking-code-hook";

import { useIntegrations } from "../context/integrations.context";
import { useResponsive } from "../utils/use-responsive";
import { FormPage } from "./contents/form-page";

const { Title } = Typography;

export const ThankYouCodat: React.FC = () => {
  const { isXs, isMobile } = useResponsive();
  const { getCodatRedirect } = useIntegrations();
  const companyId = localStorage.getItem("companyId");
 // const [url, setURL] = useState<string>();

  const { setPathPageView } = useTrackingCode();
  setPathPageView("/thank-you-codat");

  useEffect(() => {
    if (companyId) {
      getCodatRedirect
        .execute(companyId)
        .then(( data ) => {
          //setURL(data?.redirect);
        })
        .catch(( error ) => {
          console.log("error", error);
        });
    }
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FormPage displayFooter={true}>
      <Row justify="center">
        <Col span={20}>
          <Space direction={"vertical"} size={"large"} className={"full-width"}>
            <Card
              bordered={!isMobile}
              bodyStyle={isXs ? { padding: "0" } : { padding: "2rem" }}
            >
              <Space
                direction={"vertical"}
                size={"large"}
                className={"full-width"}
              >
                <Row justify="center">
                  <Title style={{ margin: 0, textAlign: 'center', width: '100%' }} level={2}>Thank you</Title>
                  <Title style={{ margin: 0, textAlign: 'center', width: '100%' }} level={4}>Our Team will now review the
                    information. We will be in touch
                    with you as soon as possible.</Title>
                </Row>
              </Space>
            </Card>
          </Space>
        </Col>
      </Row>
    </FormPage>
  );
};
